<template>
    <div>
        <div class="clearbox"></div> 
        <img class="bannerbox"  src="../../static/images/banner2.jpg" /> 
        <div class="clearbox"></div>
        
        <div class="contentlist"> 
            <div class="index-width"> 
                <div class="listbox-left"> 
                    <div class="position">
                        <span>当前位置：<a ><router-link to="/">首页</router-link></a>&nbsp;&gt;&gt;&nbsp;<a @click="gotoType('introduce')">公司介绍</a>&nbsp;&gt;&gt;&nbsp;<a ><router-link to="">大事记</router-link></a></span>
                    </div> 
                    <div class="Articlebox">
                        <h1>大事记</h1>
                        <div class="a-text-c">
                            <div v-for="(item,index) in listData" :key="index" :item="item" style="display: flex;">
                                <h2 class="h2Class">{{item.dataYear}}</h2>
                                <div style="width: 600px;">
                                    <ul class="ulClass list-paddingleft-2" v-for="(itemF,indexF) in item.dataDetails" :key="indexF">
                                        <li><p><span class="monClass" style="">{{itemF.dataMonth}}</span></p></li>
                                        <li><p class="detailClass" v-for="(itemS,indexS) in itemF.dataTipsData" :key="indexS">{{ itemS.dataTips }}</p></li>
                                    </ul>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div> 
                
                <boxRight :mainTitle="mainTitle" :liData="liData" @routerData="routerData"></boxRight>
            </div> 
        </div> 
        <div class="clearbox"></div> 
        <footerNew></footerNew>
    </div>
</template>

<script>
    import boxRight from '@/component/listBoxRight.vue'
    import footerNew from '@/component/footerNew.vue'
    export default {
        components:{
			boxRight,
            footerNew					
		},
        name: "thing",
        data(){
            return{
                mainTitle:"公司介绍",
                liData:[
                    {name:"公司简介",routerTo:"introduction",type:'1',classification:'2-1'},
                    {name:"大事记",routerTo:"thing",isActive:true,type:'2',classification:'2-2'},
                ],
                listData:[
                    {
                        dataYear:'2021',
                        dataDetails:[
                            { 
                                dataMonth:'11月',
                                dataTipsData:[
                                    {dataTips:"11月15日，由Tellus Power集团自主投资、设计、兴建并投入运营，全球最大、最先进、功能最完善的光伏超级充电站在上海松江落成"}
                                ]
                            },                          
                            { 
                                dataMonth:'9月',
                                dataTipsData:[
                                    {dataTips:"9月24日 ，Tellus Power集团宣布与奇瑞新能源强强联手，双方签署战略合作协议，努力实现“互补共赢、携手并进、共创辉煌明天”的宏伟目标。"},
                                    {dataTips:"9月15日 Tellus Power集团受邀出席“大众创业，万众创新”活动周"},
                                ]
                            },
                            { 
                                dataMonth:'7月',
                                dataTipsData:[
                                    {dataTips:"7月4日，国务院副总理马凯携北京市相关领导视察新能源基础设施时来到华贸充电站，并鼓励公司继续保持良好的态势，引领新能源行业发展。"},
                                    
                                ]
                            },
                            { 
                                dataMonth:'6月',
                                dataTipsData:[
                                    {dataTips:"6月28日，Tellus Power荣获工信部颁发2021（第二届）中国充电桩创新峰会中国充电桩最佳运营商奖项。"},
                                    
                                ]
                            },
                            { 
                                dataMonth:'3月',
                                dataTipsData:[
                                    {dataTips:"2021年3月9日，吉利帝豪ev300发布媒体品鉴会于Tellus Power新能源4S店举办。"},
                                    
                                ]
                            },
                        ]
                    },
                    {
                        dataYear:'2020',
                        dataDetails:[
                            { 
                                dataMonth:'12月',
                                dataTipsData:[
                                    {dataTips:"2020年12月4日，Tellus Power集团董事长庞雷参加第三届中国新能源汽车消费论坛，荣获“E时代领军者杰出贡献奖”。"}
                                ]
                            },                          
                            { 
                                dataMonth:'11月',
                                dataTipsData:[
                                    {dataTips:"2020年11月下旬，Tellus Power受邀参加第七届北京国际充电站（桩）技术设备展览会，荣获“金桩奖”。"},
                                  
                                ]
                            },
                            { 
                                dataMonth:'10月',
                                dataTipsData:[
                                    {dataTips:"2020年10月下旬，Tellus Power受邀参加上海国际工业博览会，丰富的展品吸引了大批国内外专业观众驻足观摩，洽谈业务。"},
                                    {dataTips:"2020年10月初，Tellus Power受邀出席顺义“新产业、新动能、新经济”投资峰会，将与中关村顺义园展开战略合作，共同构建顺义新能源智能汽车生态示范区。"},
                                ]
                            },
                            { 
                                dataMonth:'7月',
                                dataTipsData:[
                                    {dataTips:"2020年7月27日，Tellus Power受邀参加“充电桩+与共享”2016中国充电桩创新峰会，荣获2020中国充电桩十大品牌。"},
                                    
                                ]
                            },
                            { 
                                dataMonth:'4月',
                                dataTipsData:[
                                    {dataTips:"2020年4月21日，Tellus Power新能源4S店正式开业，标志着Tellus Power旗下产业链形成了从前期汽车销售到后期充电服务的完整闭环。"},
                                    {dataTips:"2020年4月29日，Tellus Power受邀参加中外知名企业投资顺义行发布会并同顺义区政策签约，成为首批入驻新园区的合作企业。"},
                                    {dataTips:"2020年4月8日，Tellus Power新能源汽车销售有限公司作为北京地区总代理受邀参加吉利帝豪EV北京上市发布会。依托Tellus Power新能源为平台，帝豪EV上市首月订单即突破千辆，成为销售黑马。"},
                                    
                                ]
                            },
                        ]
                    },
                    {
                        dataYear:'2019',
                        dataDetails:[
                            { 
                                dataMonth:'1月',
                                dataTipsData:[
                                    {dataTips:"2019年Tellus Power将以北京、上海、西安三个城市为中心，带动京津冀、长三角、西部地区以及其他城市的充电设施建设，预计在全国建设710个超级充电站，建成28800根充电桩，投资规模达35 5亿。"},
                                ]
                            },                          
                           
                           
                        ]
                    },
                    {
                        dataYear:'2018',
                        dataDetails:[
                            { 
                                dataMonth:'12月',
                                dataTipsData:[
                                    {dataTips:"Tellus Power在国贸大饭店正式发布了2018全球战略。计划在2018-2019两年时间里，投资112 5个亿，进行超级充电站和目的地充电站的全球布局。其中，在中国本土市场，推出了“3+3”战略。"},
                                    {dataTips:"Tellus Power技作为北京市首个PPP模式推行充电基础设施的建设运营方，全力推进首都新能源汽车的推广普及，集约利用土地缓解停车难题，大力开发新能源充电+立体停车设施的投资、建设和运营。"},
                                    {dataTips:"中国网财经12月31日讯 Tellus Power做市说明会29日在北京举行，说明会后公司董事长庞雷接受中国网财经记者采访。他介绍，公司移动充电车目前在上海、北京都有投放。"},
                                    {dataTips:"2月29日，Tellus Power今日在北京召开做市说明会，并宣布计划在2018-2019两年时间里，投资112 5亿元进行超级充电站和目的地充电站的全球布局。"},
                                ]
                            },                          
                            { 
                                dataMonth:'10月',
                                dataTipsData:[
                                    {dataTips:"2018年10月20日，在北京市石景山区，举行了首个光伏超级充电站的启动开工仪式。该项目总投资1500万元，建设占地约500平方米，通过立体停车设计建成后可以供约30个停车充电位。"},
                                ]
                            },    
                           
                        ]
                    },
                    {
                        dataYear:'2017',
                        dataDetails:[
                            { 
                                dataMonth:'9月',
                                dataTipsData:[
                                    {dataTips:"新三板(“全国中小企业股份转让系统”)迎来了第一家充电桩企业——Tellus Power科技有限公司。“新三板”被誉为“中国的纳斯达克”,是科技创新型企业的上市孵化器以及股权转让和投融资平台。"},
                                ]
                            },                          
                           
                           
                        ]
                    },
                    {
                        dataYear:'2016',
                        dataDetails:[
                            { 
                                dataMonth:'10月',
                                dataTipsData:[
                                    {dataTips:"Tellus Power充电桩入驻上海第一家五星级酒店（上海世茂皇家艾美酒店），使之成为上海首家拥有电动汽车充电区域的五星级酒店"},
                                ]
                            },                          
                           
                           
                        ]
                    },
                    {
                        dataYear:'2015',
                        dataDetails:[
                            { 
                                dataMonth:'10月',
                                dataTipsData:[
                                    {dataTips:"Tellus Power参加德国慕尼黑Ecar Tec展会，倡导电动汽车的发展"},
                                ]
                            },                          
                           
                           
                        ]
                    },
                ]
            }
        },
        created(){
            console.log(this.$route.query)
            let w = this.$route.query
            // this.liData.map((item,index)=>{
            //     if(item.type == w.type){
            //         item[index].isActive = true
            //     }
            // })
        },
        methods:{
            routerData(e){
                console.log(e)
                if(e.type){
                    this.$router.push({
                        path: e.routerTo,
                        query: {
                            type: e.type
                        }
                    })
                    this.$store.commit('newSet',e.classification)
                }
            },
            gotoType(e){
                this.$router.push({path: e});
                if(e == 'thing'){
                    this.$store.commit('newSet','2-2')
                }else if(e == 'introduction'){
                    this.$store.commit('newSet','2-1')
                }else{
                    this.$store.commit('newSet','2-3')
                }
                
            }
        }
    }
</script>

<style scoped>
.detailClass{
    margin-top: 0px; 
    margin-bottom: 0px; 
    padding: 15px 0px 15px 65px; 
    border-width: 0px 0px 1px; 
    border-top-style: initial; 
    border-right-style: initial; 
    border-bottom-style: solid; 
    border-left-style: initial; 
    border-top-color: initial; 
    border-right-color: initial; 
    border-bottom-color: rgb(221, 221, 221); 
    border-left-color: initial; 
    border-image: initial; 
    font-size: 15px; 
    line-height: 28px;
}
.monClass{
    margin: 0px; 
    padding: 0px; 
    border: 0px; 
    width: 52px; 
    height: 28px; 
    display: block; 
    background-color: rgb(185, 185, 185); 
    text-align: center; 
    color: rgb(255, 255, 255); 
    font-size: 18px;
}
.ulClass{
    margin: 0px; 
    padding: 0px; 
    border: 0px; 
    /* width: 80%;  */
    /* float: right;  */
    position: relative;
}
.h2Class{
    /* margin: 0px 0px 0px; */
    margin-right: 50px;
    padding: 0px; 
    font-size: 18px !important; 
    width: 80px; 
    /* float: left;  */
    color: rgb(137, 137, 137); 
    line-height: 28px;
}
.contentlist .Articlebox .a-text-c {
    font-size: 14px;
    line-height: 28px;
    color: #333333;
    display: block;
    padding: 10px 20px;
    margin-top: 15px;
}
.contentlist .Articlebox h2 {
    font-size: 14px;
    color: #CCC;
    display: block;
    line-height: 22px;
    text-align: center;
}
.contentlist .Articlebox h1 {
    display: block;
    padding: 45px 0 5px;
    text-align: center;
    font-size: 19px;
}
.contentlist .Articlebox {
    width: 780px;
    float: left;
    min-height: 600px;
}
     ul, ol, li {
    list-style: none;
}
#pages {
    padding: 14px 0 10px;
    font-family: 宋体;
    overflow: hidden;
    margin: 0 auto;
    width: 100%;
}
.text-c {
    text-align: center;
}
.contentlist .listbox-left ul.list_c {
    width: 100%;
    float: left;
    margin: 15px 0;
    overflow: hidden;
}
.contentlist .listbox-left ul.list_c li a {
    float: left;
    font-size: 14px;
    color: #333333;
}
.contentlist .listbox-left ul.list_c li a:hover {
   
    color: #18D1BB;
}
.contentlist .listbox-left ul.list_c li span {
    color: #898989;
    font-size: 14px;
    float: right;
}
.contentlist .listbox-left ul.list_c li {
    width: 100%;
    float: left;
    line-height: 30px;
    box-sizing: border-box;
}
  .footerbox .fott-box2 {
    width: 100%;
    float: left;
    height: 50px;
}
.footerbox .fott-box2 .box2-right span {
    font-size: 14px;
    color: #181818;
    margin: 0 15px;
}
.footerbox .fott-box2 .box2-right {
    float: right;
    line-height: 50px;
    color: #e4e4e4;
    font-family: Tahoma;
}
  .contentlist .listbox-right {
    float: right;
    width: 200px;
}
.contentlist .listbox-right ul li a:hover, .contentlist .listbox-right ul li a.active {
    color: #18D1BB;
}
.contentlist .listbox-right ul li a {
    float: left;
    font-size: 14px;
    color: #000;
}
.contentlist .listbox-right ul li {
    width: 100%;
    float: left;
    line-height: 32px;
    box-sizing: border-box;
    padding-left: 15px;
    background: url(../../static/images/don.gif) no-repeat 5px center;
}
.footerbox {
    margin: 0 auto;
    width: 100%;
    overflow: hidden;
    background: url(../../static/images/bottom_bg.jpg) repeat-x left bottom;
}
.contentlist .listbox-right ul {
    width: 100%;
    float: left;
    margin: 15px 0;
    height: 128px;
}
.contentlist .listbox-right h2 span {
    line-height: 48px;
    font-size: 18px;
    color: #000;
    float: left;
    margin-left: 10px;
}
.contentlist .listbox-right h2 {
    width: 100%;
    height: 48px;
    background-color: #f8f8f8;
    padding: 0 10px;
    box-sizing: border-box;
}
  .contentlist .Articlebox {
    width: 780px;
    float: left;
    min-height: 600px;
}
div, form, ul, ol, li, span, p, dl, dt, dd, img {
    margin: 0;
    padding: 0;
    border: 0;
}
.contentlist .Articlebox .a-text-c {
    font-size: 14px;
    line-height: 28px;
    color: #333333;
    display: block;
    padding: 10px 20px;
    margin-top: 15px;
}
.contentlist .Articlebox h1 {
    display: block;
    padding: 45px 0 5px;
    text-align: center;
    font-size: 19px;
}
  a {
    color: #20366f;
    text-decoration: none;
}
  .position {
    width: 100%;
    float: left;
    border-bottom: 1px solid #dddddd;
    font-family: Tahoma;
    font-size: 14px;
    color: #666666;
    padding: 15px 0;
}
.position a, .position span {
    display: inline-block;
    font-size: 14px;
    color: #666666;
    margin: 0 5px;
}
    .contentlist .listbox-left {
        width: 760px;
        float: left;
    }
  .contentlist {
    margin: 30px auto 15px;
    overflow: hidden;
    width: 100%;
}
.index-width {
    width: 1000px;
    margin: 0 auto;
    position: relative;
}
  .bannerbox {
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    height: 208px;
    object-fit: cover;
}
  .clearbox {
    border-top: 1px solid transparent !important;
    margin-top: -1px !important;
    margin-top: 0px;
    clear: both;
    font-size: 0px;
    line-height: 0px;
    height: 0px;
    border: 0px;
    visibility: hidden;
}
    *{
      box-sizing: border-box;
      margin:0;
      padding:0;
    }
</style>